import {
  BORDER_COLOR,
  CHARCOAL_GREY,
  PRIMARY_BLUE,
  FITOGRAM_BLUE_FADED_8,
  GREY,
  ICON_ERROR,
  WHITE,
} from '~/Constants/Colors.constants';
import { FONT_SIZE_LARGISH, FONT_SIZE_SMALL, FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import { makeStylesWithTypes } from '~/UIKit/Style';

export const CheckListItemListStyle = makeStylesWithTypes<
  void,
  'checkListItemListLink' | 'checkListItemListCircle' | 'checkListItemListText'
>()((_theme, _params, classes) => ({
  checkListItemListContainer: {
    position: 'relative',
    marginBottom: 10,
  },

  checkListItemListItem: {
    display: 'flex',
  },

  checkListItemListCircle: {
    height: 16,
    width: 16,
    minWidth: 16,
    border: `1.5px solid ${PRIMARY_BLUE}`,
    borderRadius: 16,
    alignSelf: 'center',
    background: PRIMARY_BLUE,
    textAlign: 'center',
    color: WHITE,
    fontWeight: 'bold',
    zIndex: 1,
    lineHeight: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > svg': {
      width: 12,
      height: 12,
    },
    '&:before': {
      content: '""',
      position: 'absolute',
    },
  },

  checkListItemExclamationMark: {
    width: 16,
    minWidth: 16,
    alignSelf: 'center',
    textAlign: 'center',
    color: ICON_ERROR,
    fontWeight: 'bold',
    zIndex: 1,
    fontSize: FONT_SIZE_LARGISH,
  },

  checkListItemListLink: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    color: CHARCOAL_GREY,
    padding: '6px 8px 6px 1px',
    marginLeft: 7,
    '& > svg': {
      color: GREY,
    },
  },

  checkListItemListFooterItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    color: CHARCOAL_GREY,
    marginTop: 8,
    padding: '6px 8px',
  },

  checkListItemListItemDisabled: {
    [`.${classes.checkListItemListCircle}`]: {
      background: WHITE,
      border: `1.5px solid ${FITOGRAM_BLUE_FADED_8}`,
      color: FITOGRAM_BLUE_FADED_8,
      fontSize: 11.5,
    },
    [`.${classes.checkListItemListText}`]: {
      opacity: 0.5,
    },
  },

  checkListItemListItemActive: {
    [`.${classes.checkListItemListCircle}`]: {
      background: WHITE,
      border: `1.5px solid ${PRIMARY_BLUE}`,
      color: PRIMARY_BLUE,
      fontSize: '11.5px',
    },
  },

  checkListItemListItemChecked: {
    [`.${classes.checkListItemListCircle}`]: {
      background: PRIMARY_BLUE,
      border: `1.5px solid ${FITOGRAM_BLUE_FADED_8}`,
      color: WHITE,
      fontSize: '11.5px',
    },
  },

  checkListItemListItemCurrentStep: {
    [`.${classes.checkListItemListLink}`]: {
      backgroundColor: FITOGRAM_BLUE_FADED_8,
      color: PRIMARY_BLUE,
    },
  },

  checkListItemListItemFooter: {
    display: 'flex',
    minHeight: 50,
    borderTop: `thin solid ${BORDER_COLOR}`,
  },

  checkListItemListText: {
    padding: '7px 8px',
    margin: '0 5px 5px 5px',
    width: '100%',
    fontSize: FONT_SIZE_SMALL,
    fontWeight: 300,
    textAlign: 'left',
    letterSpacing: '0.5px',
    lineHeight: '15px',
  },

  checkListItemListTitle: {
    fontWeight: 'bold',
    fontSize: FONT_SIZE_SMALLISH,
  },

  checkListItemListProgressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  checkListItemListProgressLine: {
    width: 2,
    flex: 1,
  },

  checkListItemListProgressLineDeactivated: {
    background: FITOGRAM_BLUE_FADED_8,
  },

  checkListItemListProgressLineActive: {
    background: PRIMARY_BLUE,
  },
}));
